
define('text!modules/campaign/bulkedit/targeting/mydata/templates/panel.html',[],function () { return '<div class="w-box w-PixelTargeting w-BulkeditMyData">\n\t<div class="w-panel-body w-body"></div>\n\t<div class="w-foot">{{>footer}}</div>\n</div>\n';});

